import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgEdit = ({ size = "regular", className = "", ...props }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M15.763 2.677a1.75 1.75 0 0 1 2.475 0l3.085 3.086a1.75 1.75 0 0 1 0 2.474L9.53 20.03a.75.75 0 0 1-.348.198l-6 1.5a.75.75 0 0 1-.91-.91l1.5-6a.75.75 0 0 1 .198-.348zm1.414 1.06a.25.25 0 0 0-.354 0L15.561 5 19 8.44l1.263-1.263a.25.25 0 0 0 0-.354zm.762 5.763L14.5 6.06l-9.323 9.323-1.146 4.586 4.586-1.146z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgEdit;
